export enum ErrorCode {
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  NOT_FOUND = 'NOT FOUND',
  FORBIDDEN = 'FORBIDDEN',
  EXPIRED_REFRESH_TOKEN = 'EXPIRED_REFRESH_TOKEN',
}
